module.exports = __webpack_public_path__ + "img/SEAD_branco.24f635d1.png";